var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-timeline-node',_vm._b({},'y-timeline-node',_vm.nodeBind,false),[(_vm.form)?_c('y-form',{attrs:{"params":_vm.form}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }